export default [
  {
    gitlab: 'https://gitlab.com/archish27',
    name: 'Archish Thakkar',
    merged_mrs: 165,
    category: 'SuperStar',
  },
  {
    gitlab: 'https://gitlab.com/gauravmarwal',
    name: 'Gaurav Marwal',
    merged_mrs: 136,
    category: 'SuperStar',
  },
  {
    gitlab: 'https://gitlab.com/gerardo-navarro',
    name: 'Gerardo Navarro',
    merged_mrs: 125,
    category: 'SuperStar',
  },
  {
    gitlab: 'https://gitlab.com/PatrickRice',
    name: 'Patrick Rice',
    merged_mrs: 99,
    category: 'SuperStar',
  },
  {
    gitlab: 'https://gitlab.com/antonkalmykov',
    name: 'Anton Kalmykov',
    merged_mrs: 71,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/Deepak18-06',
    name: 'Deepak kumar',
    merged_mrs: 53,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/hristiyan.ivanov',
    name: 'Hristiyan Ivanov',
    merged_mrs: 50,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/Taucher2003',
    name: 'Niklas van Schrick',
    merged_mrs: 48,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/schurzi',
    name: 'Martin Schurz',
    merged_mrs: 40,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/ochorocho',
    name: 'Jochen',
    merged_mrs: 39,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/bbodenmiller',
    name: 'Ben Bodenmiller',
    merged_mrs: 38,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/SunBK201',
    name: 'SunBK201',
    merged_mrs: 33,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/nwittstruck',
    name: 'Nicholas Wittstruck',
    merged_mrs: 31,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/luzhiyuan.deer',
    name: 'Zhiyuan Lu',
    merged_mrs: 29,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/zillemarco',
    name: 'Marco Zille',
    merged_mrs: 29,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/ikelax',
    name: 'Alexander Ikonomou',
    merged_mrs: 29,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/jzeng88',
    name: 'Justin Zeng',
    merged_mrs: 28,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/ttaday-ext',
    name: 'Taras Tadai',
    merged_mrs: 28,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/JeremyWuuuuu',
    name: 'Wu Jeremy',
    merged_mrs: 26,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/lifez',
    name: 'Phawin Khongkhasawan',
    merged_mrs: 26,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/X_Sheep',
    name: 'Lennard Sprong',
    merged_mrs: 25,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/imskr',
    name: 'Shubham Kumar',
    merged_mrs: 25,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/kiran-4444',
    name: 'Chandra Kiran G',
    merged_mrs: 22,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/joe-snyder',
    name: 'Joe Snyder',
    merged_mrs: 20,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/divyamtayal',
    name: 'Divyam Tayal',
    merged_mrs: 20,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/espadav8',
    name: 'Andrew Smith',
    merged_mrs: 20,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/bufferoverflow',
    name: 'Roger Meier',
    merged_mrs: 19,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/grace-chung',
    name: 'Grace Chung',
    merged_mrs: 19,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/abitrolly',
    name: 'Anatoli Babenia',
    merged_mrs: 18,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/duncanmmacleod',
    name: 'Duncan Macleod',
    merged_mrs: 17,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/nvh04121',
    name: 'Hoa Nguyen',
    merged_mrs: 17,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/mness',
    name: 'Mark Nessen',
    merged_mrs: 16,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/oceane_scania',
    name: 'Océane Legrand',
    merged_mrs: 16,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/JonstonChan',
    name: 'Jonston Chan',
    merged_mrs: 15,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/Jitsusama',
    name: 'Joel Gerber',
    merged_mrs: 15,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/nakiyama-ext',
    name: 'Noriko Akiyama',
    merged_mrs: 15,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/KevSlashNull',
    name: 'Kev',
    merged_mrs: 15,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/heidi.berry',
    name: 'Heidi Berry',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/heysujal',
    name: 'Sujal Gupta',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/ivantedja',
    name: 'Ivan Sebastian',
    merged_mrs: 14,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/jimender2',
    name: 'jimender2',
    merged_mrs: 13,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/NIKU-SINGH',
    name: 'Niku Singh',
    merged_mrs: 13,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/chaomao',
    name: 'MAO Chao',
    merged_mrs: 13,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/alexandralicht0',
    name: 'Alexandra Licht',
    merged_mrs: 13,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/vtokale',
    name: 'Vasant Tokale',
    merged_mrs: 13,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/oli_brr',
    name: 'Oliver',
    merged_mrs: 12,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/candrews',
    name: 'Craig Andrews',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/dec0dedd',
    name: 'Michał Burzyński',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/catinbag',
    name: 'Dmitry Silin',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/jlindesm',
    name: 'Jeff Lindesmith',
    merged_mrs: 11,
    category: 'Star',
  },
  {
    gitlab: 'https://gitlab.com/kaganray',
    name: 'Bekir Kagan YILDIZ',
    merged_mrs: 10,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/zzaakiirr',
    name: 'Zakir Dzhamaliddinov',
    merged_mrs: 10,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/lzampier',
    name: 'Lucas Zampieri',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/eangert-ext',
    name: 'Edward Angert',
    merged_mrs: 9,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/shangsuru',
    name: 'Henry Helm',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/banhartt',
    name: 'Thorsten Banhart',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/mvitale1989',
    name: 'mvitale1989',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/vedant-jain03',
    name: 'Vedant Jain',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/perlun',
    name: 'Per Lundberg',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/hsaid2',
    name: 'Hammad Said',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/mschoettle',
    name: 'Matthias Schoettle',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/kevin.gosa',
    name: 'Kevin-Damian Gosa',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/lankaD-ext',
    name: 'Lanka De Alwis',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/josephjose',
    name: 'Joseph Jose',
    merged_mrs: 8,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/rndmh3ro',
    name: 'Sebastian Gumprich',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/alexander.marston',
    name: 'Alex Marston',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/yushao.sqpc',
    name: 'Yu Shao Pang (SQPC)',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/ruben.aleman',
    name: 'Ruben Aleman',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/ecbrown1',
    name: 'Beth',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/wilsonpinto',
    name: 'Wilson Pinto',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/sahilsarawagi',
    name: 'Sahil Sarawagi',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/varghesejose2020',
    name: 'Varghese Jose',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/harryminsky',
    name: 'Harry Minsky',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/bahek2462774',
    name: 'Ivan Shtyrliaiev',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/tedtran2019',
    name: 'Ted Tran',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/missy-davies',
    name: 'Missy Davies',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/mptr',
    name: 'mptr',
    merged_mrs: 7,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/glensc',
    name: 'Elan Ruusamäe',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/salihudickson',
    name: 'Salihu Dickson',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/sayeedahmad',
    name: 'Sayeed Ahmad',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/max-wittig',
    name: 'Max Wittig',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/abh80',
    name: 'Abh80',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/sajibAdhi',
    name: 'Sajib Adhikary',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/pmhahn',
    name: 'Philipp Hahn',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/k.filtschew',
    name: 'Konstantin Filtschew',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/ar-mali',
    name: 'Muhammed Ali',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/daelmo',
    name: 'David Elizondo',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/toby-griffiths',
    name: 'Toby Griffiths',
    merged_mrs: 6,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/atarax665',
    name: 'Abhinav Anand',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/mvanholsteijn',
    name: 'Mark van Holsteijn',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/yasuk',
    name: 'Yasutaka Kono',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/khan-mansoor',
    name: 'Mansoor Khan',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/choznerol',
    name: 'Chou Yu Ta',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/maxthier',
    name: 'Marlon',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/waldyrious',
    name: 'Waldir Pimenta',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/G0maa',
    name: 'Mohammed Gomaa',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/michael-allan',
    name: 'Michael Allan',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/van.m.anderson',
    name: 'Van Anderson',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/santigl',
    name: 'Santiago Gil',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/Derek08',
    name: 'Derek Perkins',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/dannyelcf',
    name: 'Dannyel Cardoso da Fonseca',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/ben.boeckel',
    name: 'Ben Boeckel',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/Ishmeet06',
    name: 'Ishmeet Singh',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/mjsibanez',
    name: 'María José Salmerón Ibanez',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/maudl-ext',
    name: 'Maud Leuenberger',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
  {
    gitlab: 'https://gitlab.com/dgriffin4',
    name: 'Dennis Griffin',
    merged_mrs: 5,
    category: 'Enthusiast',
  },
];
